<template>
    <modal :show.sync=show modalClasses="medium-sized-modal modal-dialog-scrollable" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500">Lead Assignment History</h3>
            <!-- FIELD STATUS -->
            <b-row style="min-width: 350px; width: 100%; min-height: 350px; height: 100%;">
                <!-- <b-col class="mb-3 py-0" style="height: 50px;">
                </b-col> -->
                <b-col cols="12" v-if="lead_history && lead_history.length > 0" class="mt-0">
                    <div class="mb-3">
                        <p>Lead Name: <span class="font-weight-600 mx-2">{{ lead_detail.name }}</span></p>
                    </div>
                    <div v-for="history in lead_history" :key="history.id" style="overflow: auto;" class="mx-0">
                        <span class="font-weight-bold my-0 py-0 top-line">{{ history.assignment_date | dateTimeDynamicFormat }} </span><br />
                        <span>Assigned to <span class="font-weight-bold">{{ history.assign_to.name }}</span> by <span class="font-weight-bold">{{ !_gHlp.isEmpty(history.assign_by) ? history.assign_by.name : "Reassign System" }}</span></span><br/>
                        <span class="my-0 py-0 bottom-line text-danger">{{ history.remark || "-" }}</span><br />
                        <span class="my-0 py-0 bottom-line">{{ history.assignment_date | dateFormatFromNow }} | <i v-if="history.is_arcived == 1" class="text-danger">Removed Or Back To Master Shuffle</i></span><br />
                        <hr class="my-3">
                    </div>

                </b-col>
                <b-col cols="12" v-else>
                    <div class="mb-3">
                        <p>Lead Name: <span class="font-weight-600 mx-2">{{ lead_detail.name }}</span></p>
                    </div>
                    <div class="text-center">
                        <b-col cols="12">
                            <p class="text-secondary fst-italic">No Data</p>
                        </b-col>
                    </div>
                </b-col>
            </b-row>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option } from 'element-ui'
import { 
  notifyFunctionMixin,
  helperFunctionMixin,
  axios,
  services,
  getHeader
} from '@/assets/js/httpImports.js'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import '@/assets/js/formValidations.js'
import { mapState, mapActions } from 'pinia'
import { useAuthStore } from '@/stores/authStore'

export default {
    props:{
        lead_assignment_history: Boolean,
        lead_data_history: Object,
        lead_detail: Object,
    },
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin
    ],
    components: {
        Modal,
        ValidationObserver,
        ValidationProvider,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    created() {
        this.$watch(
            () => this.lead_data_history,
            (newVal) => {
                newVal.lead_id ? this.getLeadAssignmentHistory(newVal.lead_id) : ""
                // this.getLeadAssignmentHistory(newVal.lead_id)
            },
            { immediate: true }
        )
    },
    computed: {
        show: {
            get() {
                return this.lead_assignment_history;
            },
            set(newVal) {
                this.$emit('update:lead_assignment_history', newVal);
            },
        },
        ...mapState(useAuthStore,['auth_user']),
    },
    data() {
        return {
            lead_history: [],
            user_data: {},
            lead_history_list: [],
            count: 0,
        }
    },
    methods:{
        changeUser(user_id){
            let filteredData = this.all_hub_team_member.filter(element => element.team_member.id == user_id).map(element =>element.hub_team.hub_team_name)
            this.assign_to.hub_team = filteredData[0]
        },
        getLeadAssignmentHistory(lead_id){
            axios.get(services.lead + 'assignment_history/' + lead_id , {headers: getHeader()})
                .then(res => {
                    this.lead_history = []
                    this.lead_history= (res.data.data)
                })
                .catch(e => {
                    this.errorFunction(e)
                })
        },
    }
}
</script>